








































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {locationService, toastService } from '@/services';
import {ResponseCodeEnum } from '@/models';

@Component
export default class LocationQrcodeReader extends Vue {
  @Prop() public multiple!: boolean;
  @Prop() public showSkipBtn!: boolean;


  private error: string = '';
  private isError: boolean = false;
  private results: string[] = [];
  private locationIds: string[] = [];

  private onInit(promise: Promise<any>) {
    promise.catch((error) => {
      this.isError = true;
      if (error.name === 'NotAllowedError') {
        this.error = 'common.message.camera_access';
      } else if (error.name === 'NotFoundError') {
        this.error = 'common.message.camera_not_found';
      } else if (error.name === 'NotSupportedError') {
        this.error = 'common.message.required_secure_context';
      } else if (error.name === 'NotReadableError') {
        this.error = 'common.message.camera_in_use';
      } else if (error.name === 'OverconstrainedError') {
        this.error = 'common.message.camera_not_suitable';
      } else if (error.name === 'StreamApiNotSupportedError') {
        this.error = 'common.message.stream_api_not_supported';
      } else {
        this.error = error.name;
      }
    });
  }

  private onDecode(result: string) {
    if(result) {
      locationService.get(result).then((res) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
        if (this.multiple) {
          const newArray = this.results;
          const newLocationIds = this.locationIds;
          newArray.push(res.data.data.shelf1 + " - " + res.data.data.shelf2 + " - " + res.data.data.shelf3);
          newLocationIds.push(result)
          this.results = [...new Set(newArray)];
          this.locationIds = newLocationIds
        } else {
          this.results = [res.data.data.shelf1 + " - " + res.data.data.shelf2 + " - " + res.data.data.shelf3];
          this.locationIds = [result];
        }
      } else {
        toastService.errorMessage('common.message.tire_location_not_exist');  
      }
      })
    }
  }

  private removeItem(index: number) {
    this.results.splice(index, 1);
    this.locationIds.slice(index, 1);
  }

  private close() {
    this.$emit("close", true);
  }
  private skip() {
    this.results = [];
    this.locationIds = [];
    this.$emit('skip');
  }

  private confirm() {
    if (this.multiple) {
      // const locationIds = this.locationIds.join();
      const result = this.locationIds.join();
      this.$emit('onDecode', result);
    } else if (this.locationIds[this.locationIds.length - 1]) {
      const result = this.locationIds[this.locationIds.length - 1];
      this.$emit('onDecode', result);
    } else {
      this.$emit('onDecode', undefined);
    }
    this.results = [];
    this.locationIds = []
  }

}
